import { TaskCommentDto } from '@sib/api';
import { EntityCommentCard } from '@sidecar/common/components/DetailsModal';

interface TaskCommentCardProps {
  comment: TaskCommentDto;
}

export const TaskCommentCard = ({ comment }: TaskCommentCardProps) => (
  <EntityCommentCard
    authorName={comment.createdBy?.name ?? ''}
    authorAvatarUrl={comment.createdBy?.avatarUrl}
    isAuthorDeactivated={Boolean(comment.createdBy?.deletedAt)}
    createdAt={comment.createdAt}
    comment={comment.comment}
  />
);
